import { useUser } from '~/@biz_account/useUser/useUser'
import { useCompanyProfile } from '~/@pages_account-settings/profile/company-info/useCompanyProfile'
import { CompanyRegistrationForm } from './CompanyConfirmationForm'
import { Button } from '~/shadcn/ui/button/button'

function CompanyConfirmationContent() {
  const { user, reloadUser } = useUser()
  const {
    setIsCompanyMutation,
    updateCompanyDataMutation,
    isRequestingUpdateCompanyData,
    updateCompanyDataError,
  } = useCompanyProfile()
  return (
    <CompanyRegistrationForm
      defaultValues={user?.profile?.company}
      onSubmit={(company) => {
        updateCompanyDataMutation(
          { company, userConfirmedCompanyInfo: true },
          {
            onSuccess: reloadUser,
          }
        )
      }}
      isRequesting={isRequestingUpdateCompanyData}
      CancelButton={
        <Button
          variant="outline"
          type="button"
          onClick={() => {
            setIsCompanyMutation(
              { isCompany: false },
              { onSuccess: reloadUser }
            )
          }}>
          Nie som živnostník/firma
        </Button>
      }
      error={updateCompanyDataError}
    />
  )
}

export { CompanyConfirmationContent }
